<section class="master-admin-tile">
  <a class="master-admin-tile-link" alt="Mojo Admin" (click)="onImgClick($event)">
    <img class="master-admin-tile-image" alt="Brand" src="assets/MasterAdminIDSTile.png"/>
  </a>
</section>
